import { PAYMENT_STATUSES, MONGO_FILTER_OPERATORS, CURRENCIES, PAYMENT_PROVIDERS } from '@vy/types';
import { PAYMENTS_COLUMNS_KEYS } from '../payment-columns';
import type { FilterField } from '../../../../components/new-design/vyTableFilter';
import { PAYMENT_FILTERABLE_FIELDS } from '@vy/payments-types';

const OPERATORS_BY_TYPE = {
  text: [{ label: 'Contains', value: MONGO_FILTER_OPERATORS.REGEX }],
  number: [
    { label: 'Equals', value: MONGO_FILTER_OPERATORS.EQUALS },
    { label: 'Greater Than', value: MONGO_FILTER_OPERATORS.GREATER_THAN },
    { label: 'Less than', value: MONGO_FILTER_OPERATORS.LESS_THAN },
    { label: 'Greater than or equal', value: MONGO_FILTER_OPERATORS.GREATER_THAN_OR_EQUAL },
    { label: 'Less than or equal', value: MONGO_FILTER_OPERATORS.LESS_THAN_OR_EQUAL },
  ],
  date: [
    { label: 'Is on', value: MONGO_FILTER_OPERATORS.EQUALS },
    { label: 'Is after', value: MONGO_FILTER_OPERATORS.GREATER_THAN },
    { label: 'Is before', value: MONGO_FILTER_OPERATORS.LESS_THAN },
  ],
  select: [
    { label: 'Is any of', value: MONGO_FILTER_OPERATORS.IN },
    { label: 'Is not any of', value: MONGO_FILTER_OPERATORS.NOT_IN },
  ],
};

const getOperatorsByInputType = (inputType: keyof typeof OPERATORS_BY_TYPE) =>
  OPERATORS_BY_TYPE[inputType] ?? [];

const createFilterField = (
  id: string,
  label: string,
  inputType: keyof typeof OPERATORS_BY_TYPE,
  options?: { value: string; label: string }[],
): FilterField => ({
  id,
  label,
  inputType,
  operators: getOperatorsByInputType(inputType),
  ...(options && { options }),
});

const createEnumSelectField = (
  id: string,
  label: string,
  enumObject: Record<string, string | number>,
  labelMapper?: (key: string) => string,
): FilterField => {
  const options = Object.entries(enumObject).map(([key, value]) => ({
    value: String(value),
    label: labelMapper ? labelMapper(key) : key,
  }));
  return createFilterField(id, label, 'select', options);
};

export const PAYMENTS_FILTER_FIELDS: FilterField[] = [
  createEnumSelectField(PAYMENTS_COLUMNS_KEYS.STATUS, 'Status', PAYMENT_STATUSES),
  createFilterField(PAYMENT_FILTERABLE_FIELDS.CUSTOMER_NAME, 'Customer Name', 'text'),
  createFilterField(PAYMENT_FILTERABLE_FIELDS.AMOUNT, 'Amount', 'number'),
  createEnumSelectField(PAYMENT_FILTERABLE_FIELDS.CURRENCY, 'Currency', CURRENCIES, (key) => key.toUpperCase()),
  createEnumSelectField(PAYMENT_FILTERABLE_FIELDS.PAYMENT_METHOD, 'Payment Provider', { None: 'None', ...PAYMENT_PROVIDERS, }),
];
